var map = {
	"./Cert_FSPCA-FSVP_en.jpg": 5274,
	"./Cert_FSPCA-PCQI_en.jpg": 8708,
	"./Cert_ServSafe-ch.jpg": 8588,
	"./Cert_ServSafe-en.jpg": 1740,
	"./Quality_section.jpg": 1179,
	"./system/Cert_FSSC22000_ch.jpg": 3908,
	"./system/Cert_FSSC22000_en.jpg": 3860,
	"./system/Cert_HACCP_ch.jpg": 8964,
	"./system/Cert_HACCP_en.jpg": 4900,
	"./system/Cert_HALAL.jpg": 2201,
	"./system/Cert_ISO22000_ch.jpg": 5100,
	"./system/Cert_ISO22000_en.jpg": 1404,
	"./system/Cert_co2report.jpg": 5211,
	"./system/Cert_operator.jpg": 3853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8948;